export const RESET_SETTINGS = 'RESET_SETTINGS';
export const LOAD_SETTINGS = 'LOAD_SETTINGS';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const LOAD_USER_BALANCE = 'LOAD_USER_BALANCE';
export const LOAD_EXCHANGES = 'LOAD_EXCHANGES';
export const SET_EXCHANGE = 'SET_EXCHANGE';
export const LOAD_ACTIONS_STATS = 'LOAD_ACTIONS_STATS';
export const LOAD_DEEPLINK_AND_QR_SETTINGS = 'LOAD_DEEPLINK_AND_QR_SETTINGS';
export const UPDATE_DEEPLINK_AND_QR_SETTINGS = 'UPDATE_DEEPLINK_AND_QR_SETTINGS';
